<template>
  <div class="kk-subs-quota">
    <form v-if="valid">
      <div class="kk-subs-quota__content">
        <div class="kk-subs-quota__rates">
          <h3 class="kk-subs-quota__section-title">{{ $t("mybusiness.subscription.rates_title") }}¹</h3>
          <small class="kk-subs-quota__section-text"> &nbsp; </small>
          <div class="kk-subs-quota__metric-section">
            <div class="kk-subs-quota__rates__fieldset--wrapper">
              <fieldset class="kk-subs-quota__rates__fieldset">
                <legend>&nbsp;</legend>
                <div class="inner_wrapper">
                  <span>${{ fees.teams }} x</span>
                </div>
              </fieldset>
            </div>
            <!-- <custom-input type="number" :label="`$${fees.teams} x`" mode="true" disabled="true"> </custom-input> -->
          </div>
          <div class="kk-subs-quota__metric-section">
            <div class="kk-subs-quota__rates__fieldset--wrapper">
              <fieldset class="kk-subs-quota__rates__fieldset">
                <legend>&nbsp;</legend>
                <div class="inner_wrapper">
                  <span>${{ fees.users }} x</span>
                </div>
              </fieldset>
            </div>
            <!-- <custom-input type="number" :label="`$${fees.teams} x`" mode="true" disabled="true"> </custom-input> -->
          </div>
          <div class="kk-subs-quota__metric-section">
            <div class="kk-subs-quota__rates__fieldset--wrapper">
              <fieldset class="kk-subs-quota__rates__fieldset">
                <legend>&nbsp;</legend>
                <div class="inner_wrapper">
                  <span>${{ fees.designs }} x</span>
                </div>
              </fieldset>
            </div>
            <!-- <custom-input type="number" :label="`$${fees.teams} x`" mode="true" disabled="true"> </custom-input> -->
          </div>
          <div class="kk-subs-quota__metric-section">
            <div class="kk-subs-quota__rates__fieldset--wrapper">
              <fieldset class="kk-subs-quota__rates__fieldset">
                <legend>&nbsp;</legend>
                <div class="inner_wrapper">
                  <span>${{ fees.k_requests }} x</span>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="kk-subs-quota__metric-section"></div>
        </div>

        <div class="kk-subs-quota__usage">
          <h3 class="kk-subs-quota__section-title">
            {{ $t("mybusiness.subscription.usage_title") }}
          </h3>
          <small class="kk-subs-quota__section-text">
            (
            {{ format(usage.date_range.start) }}
            —
            {{ format(usage.date_range.end) }}
            )
          </small>

          <div class="kk-subs-quota__metric-section">
            <fieldset class="kk-subs-quota__metric-section--usage">
              <legend>{{ $t("mybusiness.subscription.teams") }}</legend>
              <div class="inner_wrapper">
                <div class="inner_wrapper__first-child">
                  <small>{{ usage.teams.count }}</small>
                  <small> / </small>
                </div>
                <div>
                  <input id="highest_count" v-model="usage.teams.highest_count" type="number" disabled min="0" />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span> = </span>
                  <span> ${{ (fees.teams * usage.teams.count).toFixed(2) }} </span>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="kk-subs-quota__metric-section">
            <fieldset class="kk-subs-quota__metric-section--usage">
              <legend>{{ $t("mybusiness.subscription.users") }}</legend>
              <div class="inner_wrapper">
                <div class="inner_wrapper__first-child">
                  <small>{{ usage.users.count }}</small>
                  <small> / </small>
                </div>
                <div>
                  <input id="highest_count" v-model="usage.users.highest_count" type="number" disabled min="0" />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span> = </span>
                  <span> ${{ (fees.users * usage.users.count).toFixed(2) }} </span>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="kk-subs-quota__metric-section">
            <fieldset class="kk-subs-quota__metric-section--usage">
              <legend>{{ $t("mybusiness.subscription.designs") }}</legend>
              <div class="inner_wrapper">
                <div class="inner_wrapper__first-child">
                  <small>{{ usage.designs.count }}</small>
                  <small> / </small>
                </div>
                <div>
                  <input id="highest_count" v-model="usage.designs.highest_count" type="number" disabled min="0" />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span> = </span>
                  <span> ${{ (fees.designs * usage.designs.count).toFixed(2) }} </span>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="kk-subs-quota__metric-section">
            <fieldset class="kk-subs-quota__metric-section--usage">
              <legend>{{ $t("mybusiness.subscription.k_requests") }}</legend>
              <div class="inner_wrapper">
                <div>
                  <input id="highest_count" v-model="usage.k_requests.count" type="number" disabled min="0" />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span>=</span>
                  <span> ${{ (fees.k_requests * usage.k_requests.count).toFixed(2) }} </span>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="kk-subs-quota__metric-section">
            <fieldset class="kk-subs-quota__metric-section--usage">
              <legend><span></span></legend>
              <div class="inner_wrapper total-usage">
                <div>
                  <input
                    id="highest_count"
                    type="number"
                    :placeholder="$t('mybusiness.subscription.total') + '²'"
                    disabled
                    min="0"
                  />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span>
                    ${{
                      (
                        fees.teams * usage.teams.highest_count +
                        fees.users * usage.users.highest_count +
                        fees.designs * usage.designs.highest_count +
                        fees.k_requests * usage.k_requests.count
                      ).toFixed(2)
                    }}
                  </span>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="kk-subs-quota__quota">
          <h3 class="kk-subs-quota__section-title mb-0">
            {{ $t("mybusiness.subscription.quota_title") }}
          </h3>
          <small class="kk-subs-quota__section-text"> &nbsp; </small>
          <div class="kk-subs-quota__metric-section">
            <fieldset>
              <legend>{{ $t("mybusiness.subscription.teams") }}</legend>
              <div class="inner_wrapper">
                <div>
                  <input id="highest_count" v-model="quota.teams.count" type="number" min="0" />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span>=</span>
                  <span> ${{ (fees.teams * quota.teams.count).toFixed(2) }} </span>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="kk-subs-quota__metric-section">
            <fieldset>
              <legend>{{ $t("mybusiness.subscription.users") }}</legend>
              <div class="inner_wrapper">
                <div>
                  <input
                    id="highest_count"
                    v-model="quota.users.count"
                    type="number"
                    min="0"
                    @input="validateUsersCount(quota.users.count)"
                  />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span>=</span>
                  <span> ${{ (fees.users * quota.users.count).toFixed(2) }} </span>
                </div>
              </div>
            </fieldset>
            <span v-if="!isUsersCountValid" class="error-message">Invalid user count.</span>
          </div>

          <div class="kk-subs-quota__metric-section">
            <fieldset>
              <legend>{{ $t("mybusiness.subscription.designs") }}</legend>
              <div class="inner_wrapper">
                <div>
                  <input id="highest_count" v-model="quota.designs.count" type="number" min="0" />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span>=</span>
                  <span>${{ (fees.designs * quota.designs.count).toFixed(2) }} </span>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="kk-subs-quota__metric-section">
            <fieldset>
              <legend>{{ $t("mybusiness.subscription.k_requests") }}</legend>
              <div class="inner_wrapper">
                <div>
                  <input id="highest_count" v-model="quota.k_requests.count" type="number" min="0" />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span>=</span>
                  <span> ${{ (fees.k_requests * quota.k_requests.count).toFixed(2) }} </span>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="kk-subs-quota__metric-section">
            <fieldset>
              <div class="inner_wrapper total-quota">
                <div>
                  <input
                    id="highest_count"
                    type="number"
                    :placeholder="$t('mybusiness.subscription.total') + '²'"
                    min="0"
                  />
                </div>
                <div class="kk-subs-quota__metric-calc">
                  <span>
                    ${{
                      (
                        fees.teams * quota.teams.count +
                        fees.users * quota.users.count +
                        fees.designs * quota.designs.count +
                        fees.k_requests * quota.k_requests.count
                      ).toFixed(2)
                    }}
                  </span>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      <div>
        <small>1. {{ $t("mybusiness.subscription.note1") }}</small>
      </div>
      <div>
        <small>2. {{ $t("mybusiness.subscription.note2") }}</small>
      </div>

      <div class="kk-subs-quota__buttons">
        <custom-button button-class="btn btn-default" button-type="button" @click="closePopup">
          {{ $t("mybusiness.subscription.close-btn") }}
        </custom-button>

        <custom-button button-class="btn btn-default btn-primary" button-type="submit" :mode="!valid" @click="update">
          {{ $t("mybusiness.subscription.update-btn") }}
        </custom-button>
      </div>
    </form>
  </div>
</template>

<script>
import CustomButton from "../commons/CustomButton.vue";

export default {
  components: {
    CustomButton,
  },
  emits: ["close-popup"],
  data() {
    return {
      valid: true,
      isUsersCountValid: true, // Add validation state
      rules: {
        required: (value) => !!value,
        min1: (value) => !isNaN(value) && value >= 1,
      },
    };
  },
  computed: {
    subscription() {
      return this.$store.state.subscription;
    },
    status() {
      return this.subscription.action.status;
    },
    fees() {
      return this.subscription.fees;
    },
    usage() {
      return this.subscription.usage;
    },
    quota() {
      return this.subscription.quota;
    },
  },
  mounted() {},

  methods: {
    validateUsersCount(value) {
      // Custom validation logic
      this.isUsersCountValid = this.rules.required(value) && this.rules.min1(value);
    },
    closePopup() {
      this.$emit("close-popup");
    },
    async update() {
      await this.$store.dispatch("subscription/update");
    },
    format(dateStr) {
      return new Date(dateStr).toLocaleDateString();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";

.has-error {
  border: 1px solid @kk-color-red;
}

.error-message {
  color: @kk-color-red;
  font-size: 0.9em;
}

.total-quota,
.total-usage {
  padding: 5px 0 0 0;
}

fieldset {
  border-radius: 4px;
  background: @kk-color-background;
  border: @kk_fieldset_border;
  padding: 0px 10px 5px 10px;

  :focus {
    background-color: @kk-color-white;
    border: 1px solid @kk-btn-info-color;
  }

  legend {
    font-size: 12px;
  }
}

.inner_wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__first-child {
    white-space: pre;
  }
}

.kk-subs-quota {
  &__metric-section {
    width: 100%;
  }
  &__content {
    display: flex;
    column-gap: 1rem;
  }

  &__buttons {
    margin-top: 10px;
    button:first-child {
      margin-right: 10px;
    }
  }

  &__section-title {
    text-align: center;
  }

  &__section-text {
    text-align: center;
  }

  &__rates,
  &__usage,
  &__quota {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__rates {
    width: 12rem;
  }
  &__usage {
    width: 19rem;
  }

  &__quota {
    fieldset {
      background: transparent;
      input {
        outline: none;
        border: none;
      }
    }
    width: 19rem;
  }

  &__rates {
    width: 12rem;

    fieldset {
      background-color: lightgray;
      border: 1px solid #ccc;
    }
  }

  &__metric-calc {
    display: flex;
    align-items: center;
  }
}
// 1. show the my-business btn to only paid users
// 1. load the usage, and quota
// 1. update the quota
</style>
